module.exports = __webpack_public_path__ + "static/media/luckey_7A.ced43dfa.png";